export type ContractType = "P15MIN" | "P30MIN" | "UK_P30MIN" | "P60MIN" | "BLOCK_2H" | "BLOCK_4H" | "DON" | "DB34" | "DP" | "DEP" | "DB" | "CUSTOM_BLOCK";
export type ContractStatus = string;

export interface IContractEditData {
    id: string;
    marketAreaCode: string;
    contractStatus: string;
    tenantId: string;
}
export interface IContractData extends IContractEditData {
    globalContractId: number;
    closeAt: Date;
    openAt: Date;
    contractCode: string;
    contractId: number;
    contractType: ContractType;
    lastModified: Date;
    modifiedBy: Date;
    productId: string;
    contractDate: Date;
    displayName: string;
    deliveryEndDate: Date;
    dayAheadPrice: number;
    reportProductCode: string;
    eventId: string;
    marketId: string;
    firstContractOfDayForCurrentArea: boolean;
    cacheEntryTime: number;
    dlvryAreaId?: number;
    isBackup?: boolean;
}

// These properties are fixed for the save API
export interface IAreaStatus {
    productCode: string;
    areaId: number;
    status: number;
}

export interface IContractDataResponse {
    contracts: IContractEditData[];
    action: string;
    marketAreaCodes: string[];
}

export enum Matcher {
    NPM,
    XBID,
    Backup
}

export interface IBackupContractStatus {
    tenantId: string;
    isBackupEnabled: boolean;
}

export interface INPMContractStatus {
    tenantId: string;
    isNPMEnabled: boolean;
}

export interface IXBIDContractStatus {
    tenantId: string;
    isXBIDEnabled: boolean;
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/Services/IContractData.ts